<template>
  <div class="box" v-if="employee">
    <div class="header">
      <span class="header-label">{{ `Opiekun > Dane osobowe` }}</span>
      <div class="header-actions">
        <custom-select
          v-if="employeeStatusesOptions && employeeStatusesOptions.length > 0"
          :default-value="selectedEmployeeStatusName"
          :options="employeeStatusesOptions"
          :graySelect="true"
          :large="true"
          :markSelected="true"
          :prePick="selectedEmployeeStatusId"
          style="width: 213px"
          @newPick="handleNewSelectedEmployeeStatus"
        />
        <span class="edit-data-redirect mr-4" @click="handleRedirectToEditUser"
          >Edytuj dane</span
        >
        <span class="edit-data-redirect" @click="openConfirmModalToRemoveUser"
          >Usuń</span
        >
      </div>
    </div>
    <div class="employee-data" v-if="page === 1">
      <div class="data">
        <p>
          <span class="data-label">Imię i nazwisko:</span>
          <span class="data-value"
            >{{ employee.firstName }} {{ employee.lastName }}</span
          >
          <span
            v-if="employee.mainAppUserId && panelCan('showMainAppLinking')"
            class="seniorapp-label ml-2"
            >{{ $mainAppBadge }}</span
          >
        </p>
        <p>
          <span class="data-label">Adres:</span>
          <span class="data-value">{{ formattedAddress() }}</span>
        </p>

        <p>
          <span class="data-label">Telefon:</span>
          <span class="data-value">{{ employee.phone }}</span>
        </p>

        <p>
          <span class="data-label">Email:</span>
          <span class="data-value">{{
            employee.email ? employee.email : "-"
          }}</span>
        </p>

        <p>
          <span class="data-label">NUMER KONTA:</span>
          <span class="data-value">{{ employee.accountNumber || "Brak" }}</span>
        </p>

        <p>
          <span class="data-label">Zakres opieki:</span>
          <span class="data-value">{{
            employee.scopesOfCare.map((s) => s.name).join(", ")
          }}</span>
        </p>

        <p>
          <span class="data-label">Kontakt:</span>
          <span class="data-value">{{ employee.careScopeNote || "Brak" }}</span>
        </p>

        <!-- <p>
          <span class="data-label">Kontakt:</span>
          <span class="data-value">{{ employee.employeeNote || "Brak" }}</span>
        </p> -->
      </div>

      <div class="data">
        <p>
          <span class="data-label">KARANA:</span>
          <span class="data-value"
            >{{ employee.wasPunished ? "TAK" : "NIE" }}
          </span>
        </p>
        <p>
          <span class="data-label">KOMORNIK:</span>
          <span class="data-value"
            >{{ employee.hasBailiff ? "TAK" : "NIE" }}
          </span>
        </p>
        <p>
          <span class="data-label">PRAWO JAZDY:</span>
          <span class="data-value"
            >{{ employee.hasDrivingLicense ? "TAK" : "NIE" }}
          </span>
        </p>
        <dod-custom-textarea
          style="width: 100%; padding: 0"
          placeholder="Notatka"
          :rowsNumber="5"
          :prePick="employeeNote"
          @change="(e) => (employeeNote = e)"
        />
        <p v-if="employee && employeeNote !== employee.employeeNote">
          <span
            class="save-btn"
            style="cursor: pointer"
            @click="handleSaveEmployeeNote"
          >
            Zapisz
          </span>
        </p>
      </div>
    </div>

    <div class="employee-data" v-if="page === 2">
      <div class="data">
        <p>
          <span class="data-label">PESEL:</span>
          <span class="data-value">{{ employee.pesel }}</span>
        </p>
        <p>
          <span class="data-label">DATA URODZENIA:</span>
          <span class="data-value">{{ formatDate(employee.birthDate) }}</span>
        </p>
        <p>
          <span class="data-label">NR DOWODU:</span>
          <span class="data-value">{{ employee.idNumber }}</span>
        </p>
        <p>
          <span class="data-label">NR PASZPORTU:</span>
          <span class="data-value">{{
            employee.passportNumber || "---------"
          }}</span>
        </p>
        <p>
          <span class="data-label">URZĄD SKARBOWY:</span>
          <span class="data-value">{{ employee.taxOffice }}</span>
        </p>
        <p>
          <span class="data-label">ODDZIAŁ NFZ:</span>
          <span class="data-value">{{ employee.nfzDepartment }}</span>
        </p>
        <p>
          <span class="data-label">OBYWATELSTWO:</span>
          <span class="data-value">{{
            employee.citizenship || "---------"
          }}</span>
        </p>
      </div>
      <div class="data">
        <p>
          <span class="data-label">ADRES ZAMELDOWANIE:</span>
          <span class="data-value">{{ formattedRegisteredAddress() }}</span>
        </p>
      </div>
    </div>

    <pink-pagination :total="2" @pageChanged="pageChanged" />
  </div>
</template>

<script>
import shared from "../../shared";
import CustomSelect from "../CustomSelect.vue";
import PinkPagination from "./PinkPagination.vue";
import DodCustomTextarea from "./DodCustomTextarea.vue";
export default {
  components: { CustomSelect, PinkPagination, DodCustomTextarea },
  name: "EmployeePersonalData",
  props: ["employee"],
  async mounted() {
    await this.$store.dispatch("getDodPriorities");
    await this.$store.dispatch("fetchEmployeeStatuses");
    this.selectedEmployeeStatusId = this.employee.status.id;
    this.selectedEmployeeStatusName = this.employee.status.name;
  },
  data() {
    return {
      page: 1,
      selectedEmployeeStatusName: "",
      selectedEmployeeStatusId: "",
      employeeNote: this.employee ? this.employee.employeeNote : "",
    };
  },
  methods: {
    async openConfirmModalToRemoveUser() {
      if (confirm("Czy na pewno chcesz usunąć opiekuna?")) {
        try {
          const response = await this.$store.dispatch(
            "removeEmployee",
            this.employee.id
          );
          if (response) {
            this.$notify({
              group: "success",
              text: "Pomyślnie usunięto opiekuna",
            });
            this.$router.push({ name: "Employees" });
            await this.$store.dispatch("fetchStatusesCounters");
          }
        } catch (error) {
          const errorMessage = error.response?.data?.message;
          let polishMessage = "Wystąpił błąd podczas usuwania opiekuna";

          if (errorMessage && errorMessage.includes("Forbidden delete, employee has orders")) {
            polishMessage = "Nie można usunąć pracownika, który jest przypisany do zamówienia. Należy go zarchiwizować.";
          }

          this.$notify({
            group: "error",
            text: polishMessage,
          });
        }
      }
    },
    pageChanged(page) {
      this.page = page;
    },
    formattedAddress() {
      return `${this.employee.city}, ${this.employee.street}
          ${this.employee.streetNumber}
          ${
            this.employee.houseNumber ? `m. ${this.employee.houseNumber}` : ""
          }`;
    },

    formattedRegisteredAddress() {
      return `${this.employee.registeredAddressCity}, ${
        this.employee.registeredAddressStreet
      }
          ${this.employee.registeredAddressStreetNumber}
          ${
            this.employee.registeredAddressHouseNumber
              ? `m. ${this.employee.registeredAddressHouseNumber}`
              : ""
          }`;
    },

    async handleNewSelectedEmployeeStatus(statusId) {
      await this.updateEmployee({ statusId });
    },

    async updateEmployee(data) {
      await this.$store.dispatch("editDodEmployee", {
        employeeId: this.employee.id,
        data,
      });
      await this.$store.dispatch("getEmployeeMessages", {
        employeeId: this.employee.id,
      });
    },
    formatDate(date) {
      return shared.dateToDayMonthYearFormat(date);
    },
    async handleSaveEmployeeNote() {
      const wasSend = await this.$store.dispatch("editDodEmployeeNote", {
        id: this.employee.id,
        note: this.employeeNote,
      });
      if (wasSend) {
        this.$notify({
          group: "success",
          text: "Pomyślnie zedytowana notatkę opiekuna",
        });
        await this.$store.dispatch("getEmployeeMessages", {
          employeeId: this.employee.id,
        });
      } else {
        this.$notify({
          group: "error",
          text: "Wsytąpił błąd przy edycji",
        });
      }
    },
    handleRedirectToEditUser() {
      this.employee.accountNumber = this.employee.accountNumber
        ? this.employee.accountNumber.replace(/ /g, "")
        : "";
      this.$router.push({
        path: `/dod-add-customer-and-employee`,
        query: {
          employee: JSON.stringify(this.employee),
        },
      });
    },
  },

  computed: {
    employeeStatuses() {
      return this.$store.getters.getEmployeeStatuses;
    },
    employeeStatusesOptions() {
      return this.employeeStatuses
        ? this.employeeStatuses.map((e) => ({
            value: e.id,
            name: e.name,
            shortName: e.name,
          }))
        : [];
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.header-label {
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #e2037e;
}
.employee-data {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: space-between;
}
.employee-data div {
  width: 40%;
}
.box {
  padding: 1rem;
  border-radius: 8px;
  border: 0.5px solid rgba(9, 7, 65, 0.25);
  background: #fff;
  box-shadow: 0px 4px 15px 0px rgba(96, 108, 128, 0.25);
}
.data p {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.data-label {
  font-weight: 600;
  margin-right: 1rem;
}
.header-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}
.edit-data-redirect {
  font-size: 14px;
  text-decoration: underline;
  height: fit-content;
  align-self: center;
  cursor: pointer;
}
.save-btn {
  font-size: 12px;
  text-decoration: underline;
}
</style>
